<template>
	<div
		:style="{position: 'absolute', top: '0px', left: 'calc(50% - 511px)', width: '1022px', height: '108px', fontSize: '22px', color: 'rgba(255, 255, 255, 0.9)', fontFamily: 'PingFang SC'}"
	>
		<div
			:style="{position: 'absolute', top: 'calc(50% - 49px)', left: 'calc(50% - 506px)', borderRadius: '21px', backgroundColor: 'rgba(5, 24, 33, 0.9)', backdropFilter: 'blur(13.4px)', width: '1012px', height: '98px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '12px 32px', boxSizing: 'border-box', gap: '28px'}"
		>
			<div
				:style="{flex: '1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '12px'}"
			>
				<div
					:style="{borderRadius: '12px', backgroundColor: 'rgba(40, 252, 246, 0.02)', boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset', width: '72px', height: '72px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}"
				>
					<img
						:style="{position: 'relative', width: '100%', height: '100%', objectFit: 'cover'}"
						alt=""
						src="@/assets/images/photovoltaic/dian.png"
					/>
				</div>
				<div
					:style="{flex: '1', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '16px'}"
				>
					<div :style="{position: 'relative', lineHeight: '30px'}">
						累计发电量（kwh）
					</div>
					<div
						:style="{position: 'relative', fontSize: '32px', lineHeight: '18px', fontFamily: 'Eurostile LT Std', color: '#c0fbf8'}"
					>
						{{ljfdl}}
					</div>
				</div>
			</div>
			<div
				:style="{flex: '1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '12px'}"
			>
				<div
					:style="{borderRadius: '12px', backgroundColor: 'rgba(40, 252, 246, 0.02)', boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset', width: '72px', height: '72px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}"
				>
					<img
						:style="{position: 'relative', width: '100%', height: '100%',  objectFit: 'cover'}"
						alt=""
						src="@/assets/images/photovoltaic/wang.png"
					/>
				</div>
				<div
					:style="{flex: '1', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '16px'}"
				>
					<div :style="{position: 'relative', lineHeight: '30px'}">
						上网电量（kwh）
					</div>
					<div
						:style="{position: 'relative', fontSize: '32px', lineHeight: '18px', fontFamily: 'Eurostile LT Std', color: '#c0fbf8'}"
					>
						{{swdl}}
					</div>
				</div>
			</div>
			<div
				:style="{flex: '1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '12px'}"
			>
				<div
					:style="{borderRadius: '12px', backgroundColor: 'rgba(40, 252, 246, 0.02)', boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset', width: '72px', height: '72px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}"
				>
					<img
						:style="{position: 'relative', width: '100%', height: '100%',  objectFit: 'cover'}"
						alt=""
						src="@/assets/images/photovoltaic/qian.png"
					/>
				</div>
				<div
					:style="{flex: '1', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', gap: '16px'}"
				>
					<div :style="{position: 'relative', lineHeight: '30px'}">
						累计收益（元）
					</div>
					<div
						:style="{position: 'relative', fontSize: '32px', lineHeight: '18px', fontFamily: 'Eurostile LT Std', color: '#c0fbf8'}"
					>
						{{ljsy}}
					</div>
				</div>
			</div>
		</div>
		<img
			:style="{position: 'absolute', top: 'calc(50% - 54px)', left: '0px', width: '26px', height: '108px', objectFit: 'cover'}"
			alt=""
			src="https://sass.gclme.com/api/file/Image/annex/20231228_36c7048fa003472098341fd32ef1a1c2.png"
		/>
		<img
			:style="{position: 'absolute', top: 'calc(50% - 54px)', right: '0px', width: '26px', height: '108px', objectFit: 'cover'}"
			alt=""
			src="https://sass.gclme.com/api/file/Image/annex/20231228_82d3a67c92614ceab706f7d083afe831.png"
		/>
	</div>
</template>

<script>
	import { dataInterface } from "@/api/dataInterfaceApi";
	export default {
	  components: {},
	  data() {
	    return {
				ljfdl: 0,
		    swdl: 0,
		    ljsy: 0,
	    };
	  },
	  mounted() {
			this.initData();
	  },
	  destroyed() {},
	  methods: {
	    initData() {
	      let params = {
          "enCode": "zngf-dz-leijifadianliang",// 接口code
	        "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
	      }
	      dataInterface
	        .dataFaceApi(params)
	        .then((res) => {
	          console.log('累计发电量 res:',res);
						this.ljfdl = res[0]?.ljfdl;
	        })
	        .catch((err) => {
		        console.log('累计发电量 err:',err);
	        });

		    let params2 = {
			    "enCode": "zngf-dz-shangwangdianliang",// 接口code
			    "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
		    }
		    dataInterface
			    .dataFaceApi(params2)
			    .then((res) => {
				    console.log('上网电量 res:',res);
				    this.swdl = res[0]?.swdl;
			    })
			    .catch((err) => {
				    console.log('上网电量 err:',err);
			    });

		    let params3 = {
			    "enCode": "zngf-dz-leijishouyi",// 接口code
			    "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
		    }
		    dataInterface
			    .dataFaceApi(params3)
			    .then((res) => {
				    console.log('累计收益 res:',res);
				    this.ljsy = res[0]?.ljsy;
			    })
			    .catch((err) => {
				    console.log('累计收益 err:',err);
			    });
	    },
		  format(item){
				if(item)return item.split('.')[0];
				return item;
		  },
	  },
	};
</script>
